import { requestWithToken } from '../utilities/request';

const company_path = '/api/private/companies';
const ccus_path = '/api/private/ccus';

// 会社情報(労安項目)取得API
const list = company_id => {
  return requestWithToken({
    method: 'GET',
    url: company_path.concat(`/${company_id}/green_file`),
  });
};

// 会社情報(労安項目)編集API
const update = (company_id, param) => {
  return requestWithToken({
    method: 'PATCH',
    url: company_path.concat(`/${company_id}/green_file`),
    data: param,
  });
};

// 事業者情報(労安項目)取得API
const jigyousya_list = param => {
  return requestWithToken({
    method: 'GET',
    url: ccus_path.concat(`/jigyousya/green_file`),
    params: param,
  });
};

// CCUSマスタ情報(労安項目)取得API
const ccus_list = () => {
  return requestWithToken({
    method: 'GET',
    url: ccus_path.concat(`/masters/green_file`),
  });
};

const getPartnerCompanyBranchGreenFiles = (
  company_id,
  partner_company_branch_id
) => {
  return requestWithToken({
    method: 'GET',
    url: company_path.concat(
      `/${company_id}/partner_company_branches/${partner_company_branch_id}/green_file`
    ),
  });
};

const updatePartnerCompanyBranchGreenFile = (
  company_id,
  partner_company_branch_id,
  param
) => {
  return requestWithToken({
    method: 'PATCH',
    url: company_path.concat(
      `/${company_id}/partner_company_branches/${partner_company_branch_id}/green_file`
    ),
    data: param,
  });
};

const getCompanyBranchPermissionIdsUsedGreenFile = (company_id, params) => {
  return requestWithToken({
    method: 'GET',
    url: company_path.concat(`/${company_id}/company_branch_permissions_used`),
    params,
  });
};

const getPartnerCompanyBranchPermissionIdsUsedGreenFile = (
  company_id,
  partner_company_branch_id,
  params
) => {
  return requestWithToken({
    method: 'GET',
    url: company_path.concat(
      `/${company_id}/partner_company_branches/${partner_company_branch_id}/company_branch_permissions_used`
    ),
    params,
  });
};

export const GreenService = {
  list,
  update,
  jigyousya_list,
  ccus_list,
  getPartnerCompanyBranchGreenFiles,
  updatePartnerCompanyBranchGreenFile,
  getCompanyBranchPermissionIdsUsedGreenFile,
  getPartnerCompanyBranchPermissionIdsUsedGreenFile,
};

export default GreenService;



// WEBPACK FOOTER //
// ./src/services/GreenFile.js